import { _T } from '@dana/components';
import { newFlowItem } from 'api/type';
import './level-rule.css';

const LevelRule: React.FC<{
  data: newFlowItem[] | undefined;
  title: string;
  titleList?: [string, string, string];
  isCurrentDate?: boolean;
}> = ({ data, title, titleList, isCurrentDate = false }) => {
  function getBg(index: number, i: number) {
    if (index === 0) {
      return 'bg-[#FFC186]';
    }
    if (i === 0) {
      return 'bg-[#DBEAFF]';
    }
    if (i === 1) {
      return 'bg-[#EBF1FD]';
    }
    return 'bg-[#C4EDB3]';
  }

  function getBorder(i: number) {
    if (i === 0 || i === 1) {
      return 'border-r border-black';
    }
    return '';
  }

  function getTitle() {
    if (title === _T('公会长提成')) {
      return _T('公会长提成');
    }
    if (title === _T('钻石薪资')) {
      return _T('钻石薪资');
    }
    return _T('金币薪资');
  }

  return (
    <div className="pt-[22px] w-[295px] bg-white h-[482px] rounded-[16px] flex flex-col justify-start items-center">
      <div dir="auto" className="text-center text-gray-800 text-xl font-bold font-sans">
        {_T(title)}
      </div>
      <div className="mt-[12px] w-[247px] h-[400px] rounded-[10px] overflow-scroll">
        {/* ${index === 0 ? 'h-[40px]' : 'h-[25px]'} */}
        <div className={`flex justify-center items-center border-black`}>
          <div
            className={`h-[51px] ${getBg(0, 0)}  ${getBorder(0)} flex justify-center items-center w-[87px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
          >
            {titleList ? titleList[0] : _T('等级')}
          </div>
          <div
            className={`h-[51px] ${getBg(0, 1)} ${getBorder(1)} flex justify-center items-center w-[100px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
          >
            {titleList ? titleList[1] : title === _T('钻石薪资') ? (isCurrentDate ? _T('清空钻石数') : _T('预估钻石')) : (isCurrentDate ? _T('收到的钻石') : _T('预估收到的钻石'))}
          </div>
          <div
            className={`h-[51px] ${getBg(0, 2)} ${getBorder(2)} flex justify-center items-center w-[87px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
          >
            {titleList ? titleList[2] : getTitle()}
          </div>
        </div>
        {data &&
          data.map((item, index) => (
            <div
              key={index}
              className={`flex justify-center items-center ${index !== data.length - 1 && 'border-b border-black'}`}
            >
              <div
                className={`h-[30px] ${getBg(1, 0)}  ${getBorder(0)} flex justify-center items-center w-[87px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
              >
                {String(item.id)}
              </div>
              <div
                className={`h-[30px] ${getBg(1, 1)} ${getBorder(1)} flex justify-center items-center w-[100px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
              >
                {String(item.flowTotal)}
              </div>
              <div
                className={`h-[30px] ${getBg(1, 2)} ${getBorder(2)} flex justify-center items-center w-[87px] text-[#333] text-center font-sans text-sm font-bold leading-[18px]`}
              >
                {String(item.reward)}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LevelRule;
